import {
    CLEAR_LAB_RECORD_DETAILS,
    CLEAR_LAB_RECORD_LIST,
    SET_LAB_RECORD_DETAILS,
    SET_LAB_RECORD_LIST,
    LAB_RECORD_DETAILS_ERROR,
    LAB_RECORD_DETAILS_ERROR_CLEAR,
    LAB_RECORD_DETAILS_PENDING,
    LAB_RECORD_LIST_ERROR,
    LAB_RECORD_LIST_ERROR_CLEAR,
    LAB_RECORD_LIST_PENDING,
    LAB_RECORD_EDIT_ERROR_CLEAR,
    LAB_RECORD_EDIT_ERROR,
    LAB_RECORD_EDIT_PENDING,
    LAB_RECORD_EDIT_DIALOG_CLOSE,
    LAB_RECORD_EDIT_DIALOG_OPEN,
    LAB_RECORD_CREATE_ERROR_CLEAR,
    LAB_RECORD_CREATE_ERROR,
    LAB_RECORD_CREATE_PENDING,
    LAB_RECORD_CREATE_DIALOG_CLOSE,
    LAB_RECORD_CREATE_DIALOG_OPEN,
    LAB_RECORDS_FILTER_DIALOG_OPEN,
    LAB_RECORDS_FILTER_DIALOG_CLOSE,
    SET_LAB_RECORDS_FILTER_DATA,
} from "./constants"

const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    labRecordList: null,
    labRecordListCount: 0,
    isLabRecordListPending: false,
    labRecordListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isLabRecordsFilterDialogOpen: false,
    labRecordsFilterData: null,
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    labRecordDetails: null,
    isLabRecordDetailsPending: false,
    labRecordDetailsErrorMessage: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isLabRecordCreateDialogOpen: false,
    isLabRecordCreatePending: false,
    labRecordCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isLabRecordEditDialogOpen: false,
    isLabRecordEditPending: false,
    labRecordEditErrorMessage: null,
}

const labRecords = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case LAB_RECORD_LIST_PENDING: {
            return {
                ...state,
                isLabRecordListPending: true,
                labRecordListErrorMessage: null,
            }
        }

        case SET_LAB_RECORD_LIST: {
            const { labRecordList } = action.payload || {};
            return {
                ...state,
                labRecordList: labRecordList['value'],
                labRecordListCount: labRecordList['@odata.count'],
                isLabRecordListPending: false,
                labRecordListErrorMessage: null,
            }
        }

        case LAB_RECORD_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                labRecordListErrorMessage: errorMessage,
                isLabRecordListPending: false,
                labRecordList: null,
                labRecordListCount: 0,
            }
        }

        case LAB_RECORD_LIST_ERROR_CLEAR: {
            return {
                ...state,
                labRecordListErrorMessage: null,
                isLabRecordListPending: false,
            }
        }
        case CLEAR_LAB_RECORD_LIST: {
            return {
                ...state,
                labRecordList: null,
                labRecordListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case LAB_RECORDS_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isLabRecordsFilterDialogOpen: true,
            }
        }
        case LAB_RECORDS_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isLabRecordsFilterDialogOpen: false,
            }
        }
        case SET_LAB_RECORDS_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                labRecordsFilterData: filter,
            }
        }

        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case LAB_RECORD_DETAILS_PENDING: {
            return {
                ...state,
                isLabRecordDetailsPending: true,
                labRecordDetailsErrorMessage: null,
            }
        }

        case SET_LAB_RECORD_DETAILS: {
            const { labRecordDetails } = action.payload || {};
            return {
                ...state,
                labRecordDetails: labRecordDetails,
                isLabRecordDetailsPending: false,
                labRecordDetailsErrorMessage: null,
            }
        }

        case LAB_RECORD_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                labRecordDetailsErrorMessage: errorMessage,
                isLabRecordDetailsPending: false,
                labRecordDetails: null,
            }
        }

        case LAB_RECORD_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                labRecordDetailsErrorMessage: null,
                // isLabRecordDetailsPending: false,
            }
        }
        case CLEAR_LAB_RECORD_DETAILS: {
            return {
                ...state,
                labRecordDetails: null,
            }
        }
        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case LAB_RECORD_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isLabRecordCreateDialogOpen: true,
            }
        }
        case LAB_RECORD_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isLabRecordCreateDialogOpen: false,
            }
        }

        case LAB_RECORD_CREATE_PENDING: {
            return {
                ...state,
                isLabRecordCreatePending: true,
                labRecordCreateErrorMessage: null,
            }
        }

        case LAB_RECORD_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                labRecordCreateErrorMessage: errorMessage,
                isLabRecordCreatePending: false,
            }
        }

        case LAB_RECORD_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                labRecordCreateErrorMessage: null,
                isLabRecordCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case LAB_RECORD_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isLabRecordEditDialogOpen: true,
            }
        }
        case LAB_RECORD_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isLabRecordEditDialogOpen: false,
            }
        }

        case LAB_RECORD_EDIT_PENDING: {
            return {
                ...state,
                isLabRecordEditPending: true,
                labRecordEditErrorMessage: null,
            }
        }

        case LAB_RECORD_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                labRecordEditErrorMessage: errorMessage,
                isLabRecordEditPending: false,
            }
        }

        case LAB_RECORD_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                labRecordEditErrorMessage: null,
                isLabRecordEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default labRecords;